import VueRouter from 'vue-router';

import api from './api';

import Homepage from './views/HomePage.vue';

/** Editor */
import Editor from './views/Editor/Editor.vue';
import Project from './views/Editor/Project.vue';
import Projects from './views/Editor/Projects.vue';
import SceneEditor from './views/Editor/SceneEditor.vue';

/** Editor Auth */
import Login from './views/Editor/Auth/Login.vue';
import Register from './views/Editor/Auth/Register.vue';
import Reset from './views/Editor/Auth/Reset.vue';

/** Render of Infographics */
import Infographics from './views/Infographics/Infographics.vue';

const loggedInOrRedirect = (to, from, next) => {
  if (api.auth.isAuthenticated()) {
    next();
  } else {
    next({ name: 'Login' });
  }
};

const isLogin = (to, from, next) => {
  if (api.auth.isAuthenticated()) {
    next({ name: 'Projects' });
  } else {
    next();
  }
};

const routes = [
  { path: '/', name: 'Infographics', component: Infographics },
  {
    path: '/editor',
    name: 'Editor',
    component: Editor,
    beforeEnter: loggedInOrRedirect,
    children: [
      { path: '', redirect: 'projects' },
      {
        path: 'projects',
        name: 'Projects',
        component: Projects,
        beforeEnter: loggedInOrRedirect,
      },
      {
        path: 'project/:id',
        name: 'Project',
        component: Project,
        beforeEnter: loggedInOrRedirect,
        props: true
      },
      {
        path: 'project/:id/scene/:sid',
        name: 'Scene',
        component: SceneEditor,
        beforeEnter: loggedInOrRedirect,
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    beforeEnter: isLogin,
  },
  { path: '/:scene', name: 'Infographics Scene', component: Infographics },
];

const router = new VueRouter({
  routes,
  // mode: 'history',
});

export default router;
